var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62869 18.9313C2.13878 18.9313 1.74268 18.5352 1.74268 18.0453V7.65285C1.74268 5.15116 3.7753 3.11853 6.277 3.11853H15.2414C15.7313 3.11853 16.1274 3.51463 16.1274 4.00455C16.1274 4.49446 15.7313 4.89057 15.2414 4.89057H6.277C4.75513 4.89057 3.51471 6.13099 3.51471 7.65285V18.0453C3.51471 18.5352 3.11861 18.9313 2.62869 18.9313Z",
    fill: "#243D63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7146 28H6.277C3.7753 28 1.74268 25.9674 1.74268 23.4657C1.74268 22.9758 2.13878 22.5797 2.62869 22.5797C3.11861 22.5797 3.51471 22.9758 3.51471 23.4657C3.51471 24.9876 4.75513 26.228 6.277 26.228H21.7146C23.2364 26.228 24.4768 24.9876 24.4768 23.4657V14.5743C24.4768 14.0843 24.8729 13.6882 25.3629 13.6882C25.8528 13.6882 26.2489 14.0843 26.2489 14.5743V23.4657C26.2489 25.9674 24.2162 28 21.7146 28Z",
    fill: "#243D63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 22.3607C14.0008 22.3607 13.9695 22.3607 13.9591 22.3607C13.6463 22.3503 13.3753 22.1731 13.219 21.9021L7.52762 11.4471C7.29829 11.0197 7.45465 10.4777 7.88202 10.2483C8.3094 10.019 8.85143 10.1754 9.08075 10.6027L14.0737 19.7756L25.9568 2.15953C26.2278 1.753 26.7803 1.64876 27.1868 1.91978C27.5933 2.1908 27.6975 2.74325 27.4265 3.14978L14.7304 21.975C14.5636 22.2148 14.2926 22.3607 14.0008 22.3607Z",
    fill: "#243D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcSurveyIcon);
export default __webpack_public_path__ + "static/media/LCSurveyIcon.99aefd6c566ab09311b7ae3aa6fbe0f0.svg";
export { ForwardRef as ReactComponent };